module.exports = __webpack_public_path__ + "img/lectureHall.193f7932.jpg";